import "swiper/css"
import { Autoplay } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

const RewardCarousel = ({
  items,
}: {
  items: {
    id: string
    title: string
    icon: string
  }[]
}) => {
  return (
    <div className="w-full max-w-[600px]">
      <Swiper
        modules={[Autoplay]}
        slidesPerView={"auto"}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        spaceBetween={4}
      >
        {items.map((item) => (
          <SwiperSlide key={item.id} className="!w-[130px]">
            {({ isActive }) => (
              <div
                className={`flex flex-col items-center p-4 rounded-lg transition-all duration-300 bg-white user-select-none
                  ${
                    isActive
                      ? "scale-100 border-2 border-primary shadow-lg"
                      : "scale-90 border-2 border-borderPrimary"
                  }
                `}
              >
                <div className="text-[80px]">{item.icon}</div>
                <span className="text-sm font-medium text-center">
                  {item.title}
                </span>
              </div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default RewardCarousel
